import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { number, func } from 'prop-types';

const styles = {
  popOverIcon: {
    color: '#1B1B1B',
    cursor: 'pointer',
    ['@md']: {
      transform: 'rotate(-270deg)'
    }
  }
};

function Mute({ handleToggleMute, volume }) {
  return (
    <UX2.Element.Icon
      onClick={ handleToggleMute }
      icon={ volume !== 0 ? 'muteVolume' : 'volumeUp' }
      size='medium'
      style={ styles.popOverIcon }
    />
  );
}

Mute.propTypes = {
  handleToggleMute: func,
  volume: number
};

export default Mute;
